import React from "react";

interface KxdLayoutStudioIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const KxdLayoutStudioIcon: React.FC<KxdLayoutStudioIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M18.333 0C18.775 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22496 20 1.66699V18.333C20 18.775 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.775 20 18.333 20H1.66699C1.22496 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.775 0 18.333V1.66699C0 1.22496 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22496 0 1.66699 0H18.333ZM7.12598 5C7.01497 5.00118 6.90627 5.0318 6.8125 5.08887C6.71874 5.14594 6.64322 5.22735 6.59473 5.32324L3.05957 12.3311C2.8845 12.6786 3.11089 13.0899 3.50879 13.1475L16.3135 14.9932C16.7529 15.0563 17.1074 14.654 16.9697 14.249L14.5352 7.12793C14.5041 7.03716 14.4493 6.9552 14.377 6.88965C14.3044 6.82406 14.2155 6.77636 14.1191 6.75195L7.28516 5.01953C7.23324 5.00639 7.17966 4.99942 7.12598 5ZM12.4248 10.1113L12.2422 11.7539L7.99512 10.916L8.68945 8.39941L12.4248 10.1113Z" fill="#002366"/>
    </svg>
  );
};

export default KxdLayoutStudioIcon;
